import { styled } from "styled-components";
import theme from "../../styles/theme";
import { useEffect, useState } from "react";
import moment from "moment";

const MainWrap = styled.div`
    position: absolute !important;
    top: ${(props)=> props.top ? props.top : '-0.5rem' };
    right: ${(props)=> props.right ? props.right : '0' };
    // background: ${theme.color.secondary.red};
    background: ${(props)=> props.color};   //SJK
    color: ${theme.color.white[100]};
    width: 1.8rem;
    height: 1.8rem;
    font-size: 0.8rem;
    line-height:1.8rem;
    border-radius: 50%; 
    text-align: center;
`;

// const AlertMark = ({right, top, to, color}) => {
const AlertMark = ({right, top, to, color}) => {

    const [dDay, setDday] = useState(1);

    useEffect(()=>{
        if(to){
            // setDday(moment(moment('2023-10-16').format('YYYY-MM-DD')).diff(moment(to),'days'));
            setDday(moment(moment().format('YYYY-MM-DD')).diff(moment(to),'days'));
        }
    },[to])

    //SJK: 20240822
    if (dDay === 0){
        color = theme.color.secondary.red;
    } else if (dDay === -1){
        color = theme.color.secondary.redA;
    } else {
        color = theme.color.secondary.redB;
    };

    return ( dDay < 1 && dDay > -3) && (
        <MainWrap right={right} top={top} color={color}>
            {dDay === 0 ? '오늘' : dDay}
        </MainWrap>
    )
}

export default AlertMark;